/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import {
  Container,
  Grid,
  SvgIcon,
  Table,
  TableBody,
  TableHead,
  TableRow,
} from "@material-ui/core";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { globalColors } from "../../../../../../../_metronic/_assets/sass/custom/globalColors";
import { ReactComponent as editIcon } from "../../../../../../assets/icons/pencil-alt.svg";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../../../partials/datatable/styles";
import { AppAPIService } from "../../../../../../services/AppAPIService";

import { ReactComponent as trashIcon } from "../../../../../../assets/custom-icons/trash.svg";

import { Pagination } from "@mui/material";
import { debounce } from "lodash";
import { Col, Form } from "react-bootstrap";
import { RiSearchLine } from "react-icons/ri";
import InputForm from "../../../../../../components/InputForm";
import {
  identifications,
  labelIdentification,
} from "../../../../../../enum/IdentificationTypes";
import { ConfirmModal } from "./components/ConfirmModal";
import styles from "./styles.module.scss";

const styleFeedback = {
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "20px",
  color: globalColors.textColor2,
};
const tableHeaders = [
  "Ações",
  "Nome",
  "Tipo",
  "Identificação",
  "Data de Modificação",
];

export const DocumentCategoryListing = (props) => {
  let api = AppAPIService.getInstance();
  const history = useHistory();
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [confirmedDelete, setConfirmedDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [categoryTypeOptions, setCategoryTypeOptions] = useState([]);
  const [documentCategoryList, setDocumentCategoryList] = useState([]);
  const [idToDelete, setIdToDelete] = useState(null);
  const [hasFetched, setHasFetched] = useState(false);

  const [filter, setFilter] = useState({
    typeId: null,
    identificationType: null,
    categoryType: null,
    name: null,
    labelSelect: {
      identificationType: [],
      typeId: [],
    },
    meta: {
      page: 1,
      itemsPerPage: 10,
      lastPage: 10,
    },
  });

  const handlePageChange = (event, value) => {
    setFilter((currentFilter) => ({
      ...currentFilter,
      meta: { ...currentFilter.meta, page: value ?? [] },
    }));
  };

  const getCategoryTypeOptions = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.makeHttpRequest({
        url: `/document-category-type/list-paginated`,
        method: "GET",
      });
      const categoryTypes = Array.isArray(response?.data) ? response.data : response || [];
      const categoryTypeOptionsFromApi = categoryTypes.map((categoryType) => {
        return { value: categoryType.id, label: categoryType.name };
      });
      setCategoryTypeOptions(categoryTypeOptionsFromApi);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [api]);

  const currentPage = filter.meta.page;
  const itemsPerPage = filter.meta.itemsPerPage;
  const filterName = filter.name;
  const filterTypeId = filter.typeId;
  const filterIdentificationType = filter.identificationType;

  const handleGetListOfDocumentCategory = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.makeHttpRequest({
        method: "GET",
        url: "/document-category/list-paginated",
        params: {
          page: currentPage || 1,
          perPage: itemsPerPage || 1000,
          search: filterName,
          filters: {
            typeId: filterTypeId,
            identificationType: filterIdentificationType,
          },
        },
      });
      setDocumentCategoryList(response.data);
      setFilter((currentFilter) => ({
        ...currentFilter,
        meta: {
          ...currentFilter.meta,
          lastPage: response.meta.lastPage,
        },
      }));
      setHasFetched(true);
    } catch (e) {
      Swal.fire("Erro!", "Erro ao buscar categorias de documentos.", "error");
    }
    setLoading(false);
    setHasFetched(true);
  }, [
    api,
    currentPage,
    filterIdentificationType,
    filterName,
    filterTypeId,
    itemsPerPage,
  ]);

  const handleFilter = useCallback(
    debounce((event, filterBy) => {
      setLoading(true);
      if (!event) event = {};
      setFilter((currentFilter) => ({
        ...currentFilter,
        [filterBy]: event?.value ?? event?.target?.value ?? "",
        meta: { ...currentFilter.meta, page: 1 },
        labelSelect: {
          ...currentFilter.labelSelect,
          [filterBy]: !event ? [] : event,
        },
      }));
    }, 300),
    [setFilter]
  );

  const handleConfirmDelete = useCallback(
    async (id) => {
      try {
        setLoading(true);
        const result = await api.makeHttpRequest({
          method: "DELETE",
          url: `/document-category/${id}`,
        });

        if (result?.status == 404) {
          Swal.fire(
            "Erro!",
            "Erro ao deletar parametrização de documento, categoria não encontrada.",
            "error"
          );
          return;
        }
        if (result?.status !== 200) {
          let message = "";
          // if "IN_USE" in result.response:
          if (result.response.includes("IN_USE")) {
            message = "- registro está sendo utilizado em parametrizações";
          }
          Swal.fire(
            "Erro!",
            `Erro ao deletar parametrização de documento ${message}.`,
            "error"
          );
          return;
        }

        setLoading(false);
        Swal.fire(
          "Sucesso!",
          "Parametrização de documento deletada com sucesso.",
          "success"
        ).then(() => {
          history.push("/admin/parametrizacao");
        });
      } catch (e) {
        Swal.fire(
          "Erro!",
          "Erro ao deletar parametrização de documento.",
          "error"
        );
      }
      setConfirmedDelete(false);
      setLoading(false);
    },
    [api, history]
  );

  const handleDeleteRecord = (id) => {
    setIdToDelete(id);
    setShowConfirmDeleteModal(true);
  };

  useEffect(() => {
    getCategoryTypeOptions();
  }, [getCategoryTypeOptions]);

  useEffect(() => {
    handleGetListOfDocumentCategory();
  }, [handleGetListOfDocumentCategory]);

  useEffect(() => {
    if (confirmedDelete) {
      handleConfirmDelete(idToDelete);
    }
  }, [confirmedDelete, handleConfirmDelete, idToDelete]);

  return (
    <Container
      style={{
        boxShadow: "none",
        padding: 0,
        margin: 0,
      }}
      maxWidth="xl"
    >
      <ConfirmModal
        open={showConfirmDeleteModal}
        handleOpen={setShowConfirmDeleteModal}
        handleConfirm={handleConfirmDelete}
        setConfirmedDelete={setConfirmedDelete}
        id={idToDelete}
        setId={setIdToDelete}
      />
      <Grid
        xl={12}
        lg={12}
        md={12}
        sm={12}
        xs={12}
        container
        style={{
          padding: 0,
        }}
      >
        <Grid
          className="xv-filter-grid"
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          container
          style={{}}
        >
          <Grid
            xl={4}
            lg={4}
            md={4}
            style={{
              // paddingRight: "5px",
              marginTop: "10px",
            }}
          >
            <Form.Group
              as={Col}
              xs="12"
              className={
                "rmv-all-props row-group-padding row-group-margin-bottom row-grop-margin-bottom-mobile icon-search"
              }
              style={{
                marginTop: "0",
              }}
            >
              <button type="button">
                <RiSearchLine size={20} />
              </button>
              <Form.Control
                type="text"
                name="search"
                style={{
                  paddingLeft: "60px",
                  border: `0.5px solid ${globalColors.backgroundColor2}`,
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  width: "100%",
                  display: "block",
                }}
                className={styles.searchInput}
                onChange={(e) =>
                  // handleFilterListDocumentCategory(e.target.value)
                  handleFilter(e, "name")
                }
                onFocus={(e) =>
                  (e.target.style.border = `.5px solid ${globalColors.primaryColor1}`)
                }
                onBlur={(e) =>
                  (e.target.style.border = `.5px solid ${globalColors.textColor2}70`)
                }
                size="lg"
                placeholder="Busque por nome do documento"
              />
            </Form.Group>
          </Grid>

          <Grid
            xl={4}
            lg={4}
            md={4}
            style={{
              height: "48px",
              padding: "5px 5px 0 0 ",
            }}
          >
            <InputForm
              label="Tipo"
              name="search"
              onChange={(e) => handleFilter(e, "typeId")}
              placeholder="Selecione o tipo"
              isSelect={true}
              options={categoryTypeOptions}
              value={filter.labelSelect.categoryType}
            />
          </Grid>

          <Grid
            xl={4}
            lg={4}
            md={4}
            style={{
              height: "48px",
              padding: "5px 5px 0 0 ",
            }}
          >
            <InputForm
              label="Identificação"
              name="search"
              onChange={(e) => handleFilter(e, "identificationType")}
              placeholder="Selecione uma identificação"
              isSelect={true}
              options={identifications}
              value={filter.labelSelect.identificationType}
            />
          </Grid>
        </Grid>
        <Container
          className="xv-premium-table-shell"
          maxWidth="xl"
          style={{
            boxShadow: "none",
            border: "1px solid #e0e0e0",
            borderRadius: "5px",
            padding: 0,
            textAlign: "left",
            marginTop: "20px",
          }}
        >
          <Table
            className="table"
            style={{
              marginTop: "0px",
              marginBottom: "0px",
              padding: "0px",
              borderCollapse: "collapse",
              borderSpacing: "0px",
              width: "100%",
            }}
          >
            <TableHead>
              <TableRow
                style={{
                  textAlign: "left",
                  backgroundColor: globalColors.secondaryColor3,
                }}
              >
                {tableHeaders.map((header, index) => (
                  <StyledTableCell
                    key={index}
                    style={{
                      textAlign:
                        header === "Ações" || header === "Data de Modificação"
                          ? "center"
                          : "left",
                      backgroundColor: globalColors.secondaryColor3,
                    }}
                  >
                    {header}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody
              style={{
                textAlign: "left",
              }}
            >
              {!loading &&
                documentCategoryList.map((row) => (
                  <StyledTableRow key={row.id}>
                    <StyledTableCell
                      style={{
                        width: "100px",
                        textAlign: "center",
                        padding: "4px 20px",
                      }}
                    >
                      <Container
                        maxWidth="xl"
                        style={{
                          padding: "0px 10px",
                          minWidth: "70px",
                          width: "60px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <SvgIcon
                          onClick={() => {
                            props.setEditingRecord(row);
                          }}
                          style={{
                            width: "20px",
                            height: "20px",
                            color: globalColors.backgroundColor2,
                            fill: "transparent",
                            cursor: "pointer",
                          }}
                          component={editIcon}
                        />
                        <SvgIcon
                          onClick={() => {
                            handleDeleteRecord(row.id);
                          }}
                          style={{
                            width: "20px",
                            height: "20px",
                            color: globalColors.backgroundColor2,
                            fill: "transparent",
                            cursor: "pointer",
                          }}
                          component={trashIcon}
                        />
                      </Container>
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        minWidth: "200px",
                        textAlign: "left",
                      }}
                    >
                      {row.name}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        textAlign: "left",
                      }}
                    >
                      {row.type.name}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        textAlign: "left",
                      }}
                    >
                      {labelIdentification[row.identificationType]}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {new Date(row.updatedAt)
                        .toLocaleString("pt-BR")
                        .replace(",", " - ")}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
            </TableBody>
          </Table>

          {loading && <Container style={styleFeedback}>Aguarde...</Container>}
          {!loading && hasFetched && documentCategoryList.length === 0 && (
            <Container style={styleFeedback}>
              Nenhum registro encontrado.
            </Container>
          )}

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Pagination
              count={filter.meta.lastPage}
              page={filter.meta.page}
              onChange={handlePageChange}
            />
          </div>
        </Container>
      </Grid>
    </Container>
  );
};
